import React, { Component } from "react";
import { Link } from "react-router-dom";
import profile from "../../shared/images/profile.png";
import github from "../../shared/images/github.svg";
import reddit from "../../shared/images/reddit.svg";

import "./Home.css";
class Home extends Component {
  render() {
    return (
      // <a href="https://play.google.com/store/apps/developer?id=Gumboy&hl=en">
      //     Play Store Apps
      // </a>
      <div>
        <div class="col-auto">
          <img src={profile} className="profile-image" alt="profile"></img>
          <h2>
            Hi, I'm Gumboy
            <br />
            Software Engineer pursuing a career in Application Development
            <br />A few of my interests are video games, drawing, and politics
          </h2>
        </div>
        <link
          href="https://fonts.googleapis.com/css?family=Cookie"
          rel="stylesheet"
        ></link>

        <a
          className="bmc-button"
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.buymeacoffee.com/gumboy"
        >
          <img
            src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg"
            alt="Buy me a coffee"
          ></img>
          <span style={{ marginLeft: "15px", fontSize: "28px !important" }}>
            Buy me a coffee
          </span>
        </a>
        <div class="col-auto">
          <h2> Projects</h2>
          <div class="flexbox-container centered">
            <div>
              <a
                href="https://play.google.com/store/apps/details?id=com.gumboy.survive&hl=en_US"
                style={{ padding: "15px" }}
              >
                <img
                  class="img-rounded"
                  src="https://lh3.googleusercontent.com/QZbK9UHV4X30fbZk_tmemCEXJhjTQ-GX_tdFuvs9uj96cPlSQSyPyKe49B8EmjM8Hg=s180"
                  alt="randomFacts"
                ></img>
              </a>
              <p style={{ margin: 0 }}>
                <Link to="/shrinkyprivacy">Shrinky Privacy</Link>
              </p>
            </div>
            <div>
              <a
                href="https://play.google.com/store/apps/details?id=com.gumboy.random_facts&hl=en"
                style={{ padding: "15px" }}
              >
                <img
                  src="https://lh3.googleusercontent.com/SRsm6Qq4wOjYlxY4hqjWrsSkxtCaxGYz4q9BeUc0RD-gVNt6NSoOi-m3h0tlckcRA_gz=s180"
                  alt="randomFacts"
                ></img>
              </a>
            </div>
            <div>
              <a
                href="https://play.google.com/store/apps/details?id=com.gumboy.timer_watch&hl=en"
                style={{ padding: "15px" }}
              >
                <img
                  src="https://lh3.googleusercontent.com/R_gOe_Qod7JVCPCV_WVv1sRwpxiJYqT0SbFX8nrHjZi7TSA3iQYYSi-vmtVqT4HL2Gc=s180"
                  alt="timerWatch"
                ></img>
              </a>
            </div>
          </div>
        </div>
        <div class="col-auto">
          <a
            href="https://github.com/Gumboyrbz"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={github} className="row-img" alt="github"></img>
          </a>
          <a
            href="https://reddit.com/user/Gumboyrbz"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={reddit} className="row-img" alt="reddit"></img>
          </a>
        </div>
      </div>
    );
  }
}

export default Home;
// https://lh3.googleusercontent.com/SRsm6Qq4wOjYlxY4hqjWrsSkxtCaxGYz4q9BeUc0RD-gVNt6NSoOi-m3h0tlckcRA_gz=s180
